import React from 'react';

import { localeStrings as strings } from 'applicationConfig';

const ShellBanner = (props) => {
  return (
    <div className="page-banner">
      <div className="page-title-container fix-widthed">
        <h2 className="site-caption">{strings.siteCaptions[props.titleKey] || strings.generic.siteCaption}</h2>
        <h3 className="page-title"> {strings.pageTitles[props.titleKey] || ''} &nbsp; </h3>
      </div>
    </div>
  );
};

export default ShellBanner;



// WEBPACK FOOTER //
// ./src/containers/layouts/MainLayout/ShellBanner.jsx